import PropTypes from "prop-types"
import React, { useState, useRef, useEffect } from "react"
import { Container, Row, Col } from "reactstrap"
import { FileUpload } from "primereact/fileupload"
import { Steps } from "primereact/steps"
import { Toast } from "primereact/toast"
import { Tooltip } from "primereact/tooltip"
import { Tag } from "primereact/tag"
import { ProgressBar } from "primereact/progressbar"
import { Dialog } from "primereact/dialog"
import { InputText } from "primereact/inputtext"
import { TreeSelect } from "primereact/treeselect"
import { ProgressSpinner } from "primereact/progressspinner"
import { Dropdown } from "primereact/dropdown"
import axios from "axios"
import { getToken, triggerAlert } from "utils/CommonFunctions"
import { Button } from "primereact/button"
import { MultiSelect } from "primereact/multiselect"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { useNavigate } from "react-router-dom"
import { RadioButton } from 'primereact/radiobutton';
import { CloudFog } from "lucide-react"
import CompanySelector from "./CompanySelector"
import { Modal } from "react-bootstrap"
import Swal from "sweetalert2"
import { FaFilePdf, FaFileWord } from "react-icons/fa"
import { hasLegacyWordDocument } from "utils/fileValidation"



const ImportBulkResume = () => {

  const navigate = useNavigate()
  const [activeIndex, setActiveIndex] = useState(0)
  const activeParsingTaskIdRef = useRef("");
  const parsingCancelledRef = useRef(false);
  const userInfos = JSON.parse(sessionStorage.getItem("user-info"));
  const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
  const [sourceError, setSourceError] = useState("");
  const [companyId, setCompanyId] = useState(intialcompanyId);
  const [viewVisible, setViewVisible] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [selectedResume, setSelectedResume] = useState(null)
  const [editResume, setEditResume] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const toast = useRef(null)
  const fileUploadRef = useRef(null)
  const [totalSize, setTotalSize] = useState(0)
  const [failedResumes, setFailedResumes] = useState([]);
  const [successResumes, setSuccessResumes] = useState([]);
  const [showResultModal, setShowResultModal] = useState(false); 
  const [jobs, setJobs] = useState([])
  const [categories, setCategories] = useState([])
  const [selectedCategoryKey, setSelectedCategoryKey] = useState(null)
  const [stages, setStages] = useState([])
  const [resumeSources, setResumeSources] = useState([])
  const [selectedStage, setSelectedStage] = useState("None")
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [uploadedResumeData, setUploadedResumeData] = useState([])
  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])
  const [countries, setCountries] = useState([])
  const [skills, setSkills] = useState([])
  const [fileSizes, setFileSizes] = useState({})
  const [processedFiles, setProcessedFiles] = useState(new Set())
  const [jobDetailsVisible, setJobDetailsVisible] = useState(false)
  const [selectedJobs, setSelectedJobs] = useState(null)
  const [selectedJobTitles, setSelectedJobTitles] = useState("")
  const [searchText, setSearchText] = useState("")
  const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });
  const [totalRecords, setTotalRecords] = useState(0);
  const [formData, setFormData] = useState({
    resumeFiles: [],
    duplicateAction: "add_as_a_resume",
    duplicateCriteria: "Email",
    candidateSource: "",
    selectedCategory: null,
    selectedStage: "None",
    selectedJob: "",
  })
  const [selectedCountryId, setSelectedCountryId] = useState(null)
  const [selectedStateId, setSelectedStateId] = useState(null)

  const updateResumeProcessingProgress = (value) => {
    const progressBar = document.getElementById("resume-upload-progress-bar");
    const progressText = document.getElementById("resume-upload-progress-text");

    if (progressBar) {
      progressBar.style.width = `${value}%`;
    }

    if (progressText) {
      progressText.innerText = `${value}%`;
    }
  };

  const showResumeProcessingToast = (progress = 0) => {
    Swal.fire({
      toast: true,
      customClass: { popup: "resume-processing-toast" },
      position: "top-end",
      icon: "info",
      title: "Resume upload is being processed in the background.",
      text: "Please wait while we fetch the result.",
      showConfirmButton: false,
      // confirmButtonText: "Cancel Parsing",
      // confirmButtonColor: "#dc3545",
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();

        const popup = Swal.getPopup();

        if (popup && !document.getElementById("resume-progress-wrapper")) {
          const wrapper = document.createElement("div");

          wrapper.id = "resume-progress-wrapper";
          wrapper.style.width = "100%";
          wrapper.style.marginTop = "12px";

          wrapper.innerHTML = `
            <div style="
              width:100%;
              height:8px;
              background:#e2e8f0;
              border-radius:999px;
              overflow:hidden;
            ">
              <div
                id="resume-upload-progress-bar"
                style="
                  width:${progress}%;
                  height:100%;
                  background:#6366f1;
                  transition:width .4s ease;
                "
              ></div>
            </div>

            <div
              id="resume-upload-progress-text"
              style="
                text-align:right;
                font-size:11px;
                color:#64748b;
                margin-top:4px;
              "
            >
              ${progress}%
            </div>
          `;

          popup.appendChild(wrapper);
        }
      },
    }).then(async result => {
      if (!result.isConfirmed) return;

      const taskId = activeParsingTaskIdRef.current;
      if (!taskId) {
        await Swal.fire({
          icon: "info",
          title: "Parsing is starting",
          text: "Please try cancelling again once the parsing task has started.",
          confirmButtonText: "OK",
        });
        return;
      }

      try {
        await axios.post(
          `/api/v1/resume-parsing/${taskId}/cancel/`,
          {},
          getToken() || undefined
        );
        parsingCancelledRef.current = true;
        activeParsingTaskIdRef.current = "";
        clearResumeProcessingToast();
        setIsLoading(false);
        await Swal.fire({
          icon: "success",
          title: "Resume parsing cancelled.",
          confirmButtonText: "OK",
        });
        setUploadedResumeData([]);
        setUploadedFiles([]);
      } catch (error) {
        const status = error?.response?.status;
        await Swal.fire({
          icon: status === 409 ? "info" : "error",
          title: status === 409
            ? "This parsing task has already completed."
            : status === 404
              ? "Parsing task was not found."
              : "Unable to cancel parsing. Please try again.",
          confirmButtonText: "OK",
        });
      }
    });
  };

  const clearResumeProcessingToast = () => {
    Swal.close();
  };

  const steps = [
    { label: "Choose" },
    { label: "Duplicate Check" },
    { label: "Tag Resumes" },
    { label: "Finish" },
  ]
   const handleCompanyChange = (company) => {
        if (company?.company_id) {
            setCompanyId(company?.company_id);
        }
    };
  const fetchJobs = async (page, size) => {
    setIsLoading(true)
    try {
      const response = await axios.get(`/api/v1/jobs/?page=${page + 1}&size=${size}&status=Approved / Open&company_id=${companyId}`)
      if (response?.status === 200) {
        setJobs(response?.data?.results)
        setTotalRecords(response?.data?.count)
      } else {

        triggerAlert("error", "Something went wrong")
        setJobs([])
        setTotalRecords(0)
      }
    } catch (error) {
      triggerAlert("error", error.message)
    }
    finally{
      setIsLoading(false)
    }
  }
useEffect(() => {
  fetchJobs(lazyParams.page, lazyParams.rows);
}, [companyId])



  const handleIconClick = () => {
    setJobDetailsVisible(true)
  }

  const handleSaveJobs = () => {
    const jobTitle = selectedJobs
      ? `${selectedJobs.job_number} - ${selectedJobs.job_title}`
      : ""
    setSelectedJobTitles(jobTitle)
    setFormData(prev => ({
      ...prev,
      selectedJob: selectedJobs ? selectedJobs.job_id : "",
    }))
    setJobDetailsVisible(false)
  }

  const handleRefreshJobs = () => {
    setSelectedJobs(null)
    setSelectedJobTitles("")
    setSearchText("")
  }

  const onPageChange = (event) => {
    setLazyParams({ page: event.page, rows: event.rows });
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-categories/")
      if (response?.status === 200) {
        const categoryData = response?.data?.results
        const tree = buildCategoryTree(categoryData)
        setCategories(tree)
      } else {
        triggerAlert("error", "Failed to fetch categories")
      }
    } catch (error) {
      triggerAlert("error", error.message)
    }
  }

  const fetchStages = async () => {
    try {
      const response = await axios.get(
        "/api/v1/get-all-stages/"
      )
      if (response?.status === 200) {
        setStages(response?.data?.results)
      } else {
        triggerAlert("error", "Failed to fetch stages")
      }
    } catch (error) {
      triggerAlert("error", error.message)
    }
  }

  const fetchResumeSources = async () => {
    try {
      const response = await axios.get(
        "/api/v1/get-all-resume-source-types/"
      )
      if (response?.status === 200) {
        setResumeSources(response?.data?.results)
      } else {
        triggerAlert("error", "Failed to fetch resume sources")
      }
    } catch (error) {
      triggerAlert("error", error.message)
    }
  }

  const fetchStates = async countryId => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-states/?country_id=${countryId}`
      )
      if (response?.status === 200) {
        setStates(response?.data?.results)
      } else {
        triggerAlert("error", "Failed to fetch states")
      }
    } catch (error) {
      triggerAlert("error", error.message)
    }
  }

  const fetchCities = async stateId => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-cities/?state_id=${stateId}`
      )
      if (response?.status === 200) {
        setCities(response?.data?.results)
      } else {
        triggerAlert("error", "Failed to fetch cities")
      }
    } catch (error) {
      triggerAlert("error", error.message)
    }
  }

  const fetchCountries = async () => {
    try {
      const response = await axios.get(
        "/api/v1/get-all-countries/"
      )
      if (response?.status === 200) {
        setCountries(response?.data?.results)
      } else {
        triggerAlert("error", "Failed to fetch countries")
      }
    } catch (error) {
      triggerAlert("error", error.message)
    }
  }

  const fetchSkills = async () => {
    try {
      const response = await axios.get(
        "/api/v1/get-all-skills/"
      )
      if (response?.status === 200) {
        setSkills(response.data.results)
      } else {
        triggerAlert("error", "Failed to fetch skills")
      }
    } catch (error) {
      triggerAlert("error", error.message)
    }
  }

  const buildCategoryTree = categories => {
    const categoryMap = new Map()
    const tree = []

    categories?.forEach(category => {
      categoryMap.set(category.category_id, {
        key: category.category_id.toString(),
        label: category.name,
        children: [],
        data: category,
      })
    })

    categories.forEach(category => {
      if (!category.is_deleted && !category.archived) {
        const node = categoryMap?.get(category.category_id)
        if (category.parent_category) {
          const parent = categoryMap?.get(category.parent_category.category_id)
          if (parent) {
            parent?.children?.push(node)
          }
        } else {
          tree.push(node)
        }
      }
    })

    const sortChildren = node => {
      node.children.sort((a, b) => a.label.localeCompare(b.label))
      node.children.forEach(sortChildren)
    }
    tree.sort((a, b) => a.label.localeCompare(b.label))
    tree.forEach(sortChildren)

    return tree
  }

  useEffect(() => {
    fetchJobs(lazyParams.page, lazyParams.rows);
  }, [lazyParams])

  useEffect(() => {

    fetchCategories()
    fetchStages()
    fetchResumeSources()
    fetchCountries()
    fetchSkills()
  }, [activeIndex])

  // Sync files back to FileUpload component when returning to step 0
  useEffect(() => {
    if (activeIndex === 0 && fileUploadRef.current && uploadedFiles.length > 0) {
      fileUploadRef.current.setFiles(uploadedFiles);
    }
  }, [activeIndex, uploadedFiles])

  // const onTemplateSelect = e => {
  //   const files = e.files
  //   const allowedTypes = [
  //     "application/pdf",
  //     "application/msword",
  //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //     "image/png",
  //     "image/jpeg",
  //     "image/jpg",
  //   ]
  //   let newTotalSize = totalSize
  //   const newFileSizes = {}
  //   const validFiles = []

  //   // Validate file types and calculate total size
  //   let hasInvalidType = false
  //   Array.from(files).forEach(file => {
  //     if (!allowedTypes.includes(file.type)) {
  //       hasInvalidType = true
  //     } else {
  //       newTotalSize += file.size || 0
  //     }
  //   })

  //   // Reject all files if any have invalid type or if total size exceeds 5MB
  //   if (hasInvalidType) {
  //     toast.current.show({
  //       severity: "error",
  //       summary: "Error",
  //       detail: "Invalid file type detected. Only PDF, DOC, DOCX, PNG, JPEG, and JPG files are allowed.",
  //     })
  //     return
  //   }
  //   if (newTotalSize > 5000000) {
  //     toast.current.show({
  //       severity: "error",
  //       summary: "Error",
  //       detail: "Cannot upload files. Total size of all files would exceed 5MB limit.",
  //     })
  //     return
  //   }

  //   // Process valid files
  //   Array.from(files).forEach(file => {
  //     newFileSizes[file.name.trim().toLowerCase()] = file.size || 0
  //     validFiles.push(file)
  //     console.log(`Uploaded File: ${file.name}, Size: ${file.size} bytes`)
  //   })

  //   setTotalSize(newTotalSize)
  //   setUploadedFiles([...uploadedFiles, ...validFiles])
  //   setFileSizes(prev => {
  //     const updatedSizes = { ...prev, ...newFileSizes }
  //     console.log("Updated fileSizes:", updatedSizes)
  //     return updatedSizes
  //   })
  //   setFormData(prev => ({
  //     ...prev,
  //     resumeFiles: [...uploadedFiles, ...validFiles],
  //   }))
  // }

  // const onBeforeSelect = (event) => {
  //   const allowedTypes = [
  //     "application/pdf",
  //     "application/msword",
  //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //   ];

  //   const allowedExtensions = [".pdf", ".doc", ".docx"];

  //   const files = event.files;
  //    const invalid = event.files.filter((file) => {
  //     const ext = file?.name
  //       .substring(file?.name?.lastIndexOf("."))
  //        .toLowerCase();
  //      console.log("ext:", ext, "file.type:", file.type);
  //     return (
  //       !allowedTypes.includes(file.type) ||
  //       !allowedExtensions.includes(ext)
  //     );
  //   });

  //   if (invalid.length > 0) {
  //     toast.current.show({
  //       severity: "error",
  //       summary: "Invalid file",
  //       detail: "Only PDF, DOC, DOCX files are allowed.",
  //     });
  //     event.files = []; // ⚠️ Prevents selection entirely
  //   }
  // };
  const onBeforeSelect = (event) => {
    // Let onTemplateSelect handle validation to avoid duplicate error messages
  };


  // processing workign code
  //   const onTemplateSelect = (event) => {
  //   const allowedExtensions = [".pdf", ".doc", ".docx"];
  //   const allowedTypes = [
  //     "application/pdf",
  //     "application/msword",
  //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //   ];

  //   // Find only newly selected files
  //   const newFiles = event.files.filter(file => 
  //     !processedFiles.has(file.name.toLowerCase().trim())
  //   );

  //   const newValidFiles = [];
  //   const newInvalidFiles = [];

  //   newFiles.forEach((file) => {
  //     const ext = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
  //     if (allowedTypes.includes(file.type) && allowedExtensions.includes(ext)) {
  //       newValidFiles.push(file);
  //     } else {
  //       newInvalidFiles.push(file);
  //     }
  //   });

  //   // Show error only for newly selected invalid files
  //   if (newInvalidFiles.length > 0) {
  //     toast.current.show({
  //       severity: "error",
  //       summary: "Invalid file",
  //       detail: "Only PDF, DOC, DOCX files are allowed.",
  //     });
  //   }

  //   // Update processed files tracker
  //   setProcessedFiles(prev => {
  //     const updated = new Set(prev);
  //     newFiles.forEach(file => updated.add(file.name.toLowerCase().trim()));
  //     return updated;
  //   });

  //   // Only add valid files
  //   if (newValidFiles.length > 0) {
  //     setUploadedFiles((prev) => {
  //       const existing = new Map(
  //         prev.map((f) => [f.name.toLowerCase().trim(), f])
  //       );

  //       newValidFiles.forEach((file) => {
  //         const key = file.name.toLowerCase().trim();
  //         if (!existing.has(key)) {
  //           existing.set(key, file);
  //         }
  //       });

  //       return Array.from(existing.values());
  //     });

  //     setFormData((prev) => {
  //       const existing = new Map(
  //         prev.resumeFiles.map((f) => [f.name.toLowerCase().trim(), f])
  //       );

  //       newValidFiles.forEach((file) => {
  //         const key = file.name.toLowerCase().trim();
  //         if (!existing.has(key)) {
  //           existing.set(key, file);
  //         }
  //       });

  //       return { ...prev, resumeFiles: Array.from(existing.values()) };
  //     });
  //   }
  // };

  const onTemplateSelect = (event) => {
    const allowedExtensions = [".pdf", ".doc", ".docx"];
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    // Track newly selected files
    const newFiles = event.files.filter(
      (file) => !processedFiles.has(file.name.toLowerCase().trim())
    );

    if (newFiles.length === 0) return; // Nothing new to process

    const newValidFiles = [];
    const newInvalidFiles = [];

    newFiles.forEach((file) => {
      const ext = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
      if (allowedTypes.includes(file.type) && allowedExtensions.includes(ext)) {
        newValidFiles.push(file);
      } else {
        newInvalidFiles.push(file);
      }
    });

    // Show error only for newly selected invalid files
    if (newInvalidFiles.length > 0) {
      toast.current.show({
        severity: "error",
        summary: "Invalid file",
        detail: "Only PDF, DOC, DOCX files are allowed.",
      });
    }

    // ✅ Add valid files to uploaded state
    if (newValidFiles.length > 0) {
      let newTotalSize = totalSize;
      const newFileSizes = {};
      
      newValidFiles.forEach((file) => {
        const fileName = file.name.toLowerCase().trim();
        const fileSize = file.size || 0;
        newFileSizes[fileName] = fileSize;
        newTotalSize += fileSize;
      });
      
      setTotalSize(newTotalSize);
      setFileSizes(prev => ({ ...prev, ...newFileSizes }));
      
      setUploadedFiles((prev) => {
        const existing = new Map(prev.map((f) => [f.name.toLowerCase().trim(), f]));
        newValidFiles.forEach((file) => {
          const key = file.name.toLowerCase().trim();
          if (!existing.has(key)) existing.set(key, file);
        });
        return Array.from(existing.values());
      });

      setFormData((prev) => {
        const existing = new Map(prev.resumeFiles.map((f) => [f.name.toLowerCase().trim(), f]));
        newValidFiles.forEach((file) => {
          const key = file.name.toLowerCase().trim();
          if (!existing.has(key)) existing.set(key, file);
        });
        return { ...prev, resumeFiles: Array.from(existing.values()) };
      });
    }

    // ✅ Update processed files tracker AFTER handling
    setProcessedFiles((prev) => {
      const updated = new Set(prev);
      newFiles.forEach((file) => updated.add(file.name.toLowerCase().trim()));
      return updated;
    });
  };





  const onTemplateUpload = e => {
    let _totalSize = 0
    const newFileSizes = {}
    e.files.forEach(file => {
      _totalSize += file.size || 0
      newFileSizes[file.name] = file.size || 0
    })
    setTotalSize(_totalSize);
    // console.log("onTemplateUpload - validFiles:", e.files);
    setUploadedFiles(e.files)
    setFileSizes(newFileSizes)
    setFormData(prev => ({ ...prev, resumeFiles: e.files }))
    toast.current.show({
      severity: "info",
      summary: "Success",
      detail: "File Uploaded",
    })
  }

  // console.log("uploadedFiles:", uploadedFiles);

  const onTemplateRemove = (file, callback) => {
    const fileName = file.name.trim().toLowerCase();
    const fileSize = fileSizes[fileName] || 0;
    const newTotalSize = totalSize - fileSize;
    setTotalSize(newTotalSize >= 0 ? newTotalSize : 0);
    const updatedFiles = uploadedFiles.filter(f => f.name.trim().toLowerCase() !== fileName);
    // console.log("onTemplateRemove - updatedFiles:", updatedFiles);
    setUploadedFiles(updatedFiles);
    setFileSizes(prev => {
      const newSizes = { ...prev };
      delete newSizes[fileName];
      return newSizes;
    });
    setFormData(prev => ({ ...prev, resumeFiles: updatedFiles }));
    callback();
  };

  const onTemplateClear = () => {
    setTotalSize(0)
    setUploadedFiles([])
    setUploadedResumeData([])
    setFileSizes({})
    setProcessedFiles(new Set())
    setFormData(prev => ({ ...prev, resumeFiles: [] }))
  }

const uploadResumesToApi = async () => {
  if (await hasLegacyWordDocument(uploadedFiles)) {
    await Swal.fire({
      icon: "warning",
      title: "Microsoft Word 97-2003 Document",
      text: "This .doc file cannot be parsed. Please upload the resume in PDF or DOCX format.",
      confirmButtonText: "OK",
    });
    return false;
  }

  setIsLoading(true);
  try {
    const formData = new FormData();
    uploadedFiles.forEach(file => formData.append("resume_files", file));
    const response = await axios.post(
      "/api/v1/parse-resume/",
      formData
    );
    if (response?.status === 200) {
      const resumeDataWithSize = response?.data?.data?.map((resume, index) => ({
        ...resume,
        file_name: uploadedFiles[index]?.name,
        file_size: fileSizes[uploadedFiles[index]?.name?.trim().toLowerCase()] || 0,
      }));
      setUploadedResumeData(resumeDataWithSize);
      if (response?.data?.failed_resumes?.length > 0) {
        const failedFiles = response.data.failed_resumes.map(f => f.file_name).join(", ");
        clearResumeProcessingToast();
        toast.current.show({
          severity: "error",
          summary: "Upload Failed",
          detail: `Failed to upload: ${failedFiles}`,
        });
        return false;
      }

      clearResumeProcessingToast();
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Resumes parsed successfully",
      });
      return true;
    } else {
      clearResumeProcessingToast();
      triggerAlert("error", "Failed to parse resumes");
      return false;
    }
  } catch (error) {
    clearResumeProcessingToast();
    triggerAlert("error", error.message);
    return false;
  } finally {
    setIsLoading(false);
  }
};
const waitForUploadTask = (taskId) => {
  activeParsingTaskIdRef.current = taskId;
  parsingCancelledRef.current = false;
  return new Promise((resolve, reject) => {
    let progress = 10;

    const checkTaskStatus = async () => {
      if (parsingCancelledRef.current) {
        reject(new Error("Resume parsing cancelled."));
        return;
      }
      try {
        progress = Math.min(progress + 20, 90);
        updateResumeProcessingProgress(progress);

        const response = await axios.get(`/api/v1/task-status/${taskId}/`);
        const taskData = response?.data || {};
        const status = String(taskData?.status || "").toUpperCase();

        if (status === "SUCCESS") {
          updateResumeProcessingProgress(100);
          setTimeout(() => {
            Swal.close();
          }, 500);
          resolve({
            status,
            data: taskData.result,
          });
        } else if (status === "FAILURE" || status === "FAILED") {
          Swal.close();
          reject(new Error(taskData?.error || "Task failed"));
        } else {
          setTimeout(checkTaskStatus, 1000);
        }
      } catch (err) {
        Swal.close();
        reject(err);
      }
    };
    checkTaskStatus();
  });
};
  //   const uploadResumesToApi = async () => {
  //   setIsLoading(true);
  //   try {
  //     const resumeDataWithSize = [];
  //     for (let index = 0; index < uploadedFiles.length; index++) {
  //       const file = uploadedFiles[index];
  //       const formData = new FormData();
  //       formData.append("resume_files", file);

  //       const response = await axios.post(
  //         "http://54.161.19.209:8000/api/resume/",
  //         formData
  //       );

  //       if (response?.status === 200) {
  //         const resume = response?.data?.data[0]; // Assuming API returns single resume data
  //         resumeDataWithSize.push({
  //           ...resume,
  //           file_name: file?.name,
  //           file_size: fileSizes[file?.name?.trim().toLowerCase()] || 0,
  //         });
  //       } else {
  //         triggerAlert("error", `Failed to upload resume: ${file.name}`);
  //         return false;
  //       }
  //     }

  //     setUploadedResumeData(resumeDataWithSize);
  //     console.log("resumeDataWithSize:", resumeDataWithSize);
  //     toast.current.show({
  //       severity: "success",
  //       summary: "Success",
  //       detail: "Resumes uploaded successfully",
  //     });
  //     return true;
  //   } catch (error) {
  //     triggerAlert("error", error.message);
  //     return false;
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const saveEditedResume = () => {
    setUploadedResumeData(prev => {
      // Create a new array to avoid mutating state directly
      const updatedData = [...prev];
      // Find the index of the resume to update using a unique identifier (e.g., id or file_name)
      const index = updatedData.findIndex(resume => resume.id === editResume.id && resume.file_name === editResume.file_name);

      if (index !== -1) {
        // Ensure all necessary metadata is preserved
        updatedData[index] = {
          ...editResume,
          file_name: updatedData[index].file_name, // Preserve file_name
          file_size: updatedData[index].file_size, // Preserve file_size
        };
      } else {
        // Log an error if the resume is not found (for debugging)
        console.error("Resume not found in uploadedResumeData:", editResume);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to update resume: Candidate not found.",
        });
      }

      return updatedData;
    });

    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Candidate updated successfully",
    });

    setEditVisible(false);
    setEditResume(null);
  };

  const cancelEditResume = () => {
    setEditVisible(false)
    setEditResume(null)
  }

  // const handleSubmit = async () => {
  //     if (!formData.candidateSource) {
  //   triggerAlert("error", "Candidate Source is mandatory. Please select a source.");
  //   return;
  // }
  //   setIsLoading(true);
  //   try {
  //     const convertToBase64 = file => {
  //       return new Promise((resolve, reject) => {
  //         const reader = new FileReader();
  //         reader.readAsDataURL(file);
  //         reader.onload = () => resolve(reader.result.split(",")[1]);
  //         reader.onerror = error => reject(error);
  //       });
  //     };

  //     const candidates = await Promise.all(
  //       uploadedResumeData.map(async (resume, index) => {
  //         const file = uploadedFiles[index];
  //         if (!file) return null;

  //         const base64Data = await convertToBase64(file);
  //         const fileExtension = file.name.split(".").pop().toLowerCase();
  //         const fileName = file.name;

  //         const firstName = Array.isArray(resume.contact_info?.first_name)
  //           ? resume.contact_info.first_name[0] || "Unknown"
  //           : String(resume.contact_info?.first_name || "Unknown");
  //         const lastName = Array.isArray(resume.contact_info?.last_name)
  //           ? resume.contact_info.last_name[0] || ""
  //           : String(resume.contact_info?.last_name || "");
  //         const middleName = Array.isArray(resume.contact_info?.middle_name)
  //           ? resume.contact_info.middle_name[0] || ""
  //           : String(resume.contact_info?.middle_name || "");
  //         const email = Array.isArray(resume.contact_info?.email)
  //           ? resume.contact_info.email[0] || ""
  //           : String(resume.contact_info?.email || "");
  //         const phone = Array.isArray(resume.contact_info?.phone)
  //           ? resume.contact_info.phone[0] || ""
  //           : String(resume.contact_info?.phone || "");
  //         const totalExperience = Array.isArray(resume.contact_info?.total_experience)
  //           ? Number(resume.contact_info.total_experience[0]) +
  //           Number(resume.contact_info.total_experience[1] || 0) / 100
  //           : 0;
  //         const employerName = resume.employment_history?.employer_1?.employer_name || "";
  //         const position = resume.employment_history?.employer_1?.position || "";
  //         const startDate = resume.employment_history?.employer_1?.start_date || "";
  //         const endDate = resume.employment_history?.employer_1?.end_date || "";
  //         const employer2Name = resume.employment_history?.employer_2?.employer_name || "";
  //         const position2 = resume.employment_history?.employer_2?.position || "";
  //         const startDate2 = resume.employment_history?.employer_2?.start_date || "";
  //         const endDate2 = resume.employment_history?.employer_2?.end_date || "";
  //         const referredBy = resume.referred_by || "";
  //         const country = Array.isArray(resume.contact_info?.country)
  //           ? resume.contact_info.country[0] || ""
  //           : String(resume.contact_info?.country || "");
  //         const city = Array.isArray(resume.contact_info?.city)
  //           ? resume.contact_info.city[0] || ""
  //           : String(resume.contact_info?.city || "");
  //         const region = Array.isArray(resume.contact_info?.region)
  //           ? resume.contact_info.region[0] || ""
  //           : String(resume.contact_info?.region || "");
  //         const primarySkills = Array.isArray(resume.primary_skills)
  //           ? resume.primary_skills
  //           : [];
  //         const secondarySkills = Array.isArray(resume.secondary_skills)
  //           ? resume.secondary_skills
  //           : [];
  //         const otherSkills = Array.isArray(resume.other_skills)
  //           ? resume.other_skills
  //           : [];
  //         const degreeName = resume.education_history?.education_1?.degree_name || "";
  //         const schoolName = resume.education_history?.education_1?.school_name || "";
  //         const lastEducationDate = resume.education_history?.education_1?.last_education_date || "";
  //         const major1 = resume.education_history?.education_1?.major || "";
  //         const degreeName2 = resume.education_history?.education_2?.degree_name || "";
  //         const schoolName2 = resume.education_history?.education_2?.school_name || "";
  //         const lastEducationDate2 = resume.education_history?.education_2?.last_education_date || "";
  //         const major2 = resume.education_history?.education_2?.major || "";
  //         const certifications = Array.isArray(resume.extras?.certifications)
  //           ? resume.extras.certifications.map(cert => `${cert}, Unknown, Unknown`)
  //           : [];

  //         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //         if (email && !emailRegex.test(email)) {
  //           toast.current.show({
  //             severity: "warn",
  //             summary: "Warning",
  //             detail: `Invalid email format for ${fileName}: ${email}.`,
  //           });
  //           return null;
  //         }

  //         if (!firstName || firstName.trim() === "") {
  //           toast.current.show({
  //             severity: "warn",
  //             summary: "Warning",
  //             detail: `First name is missing for ${fileName}.`,
  //           });
  //           return null;
  //         }

  //         return {
  //           first_name: firstName,
  //           middle_name: middleName,
  //           last_name: lastName,
  //           email: email,
  //           phone: phone,
  //           total_experience: totalExperience,
  //           employer_name: employerName,
  //           position: position,
  //           referred_by: referredBy,
  //           country: country,
  //           city: city,
  //           region: region,
  //           primary_skills: primarySkills,
  //           secondary_skills: secondarySkills,
  //           other_skills: otherSkills,
  //           education_history: {
  //             education_1: {
  //               school_name: schoolName,
  //               degree_name: degreeName,
  //               major: major1,
  //               last_education_date: lastEducationDate,
  //             },
  //             ...(degreeName2 && {
  //               education_2: {
  //                 school_name: schoolName2,
  //                 degree_name: degreeName2,
  //                 major: major2,
  //                 last_education_date: lastEducationDate2,
  //               },
  //             }),
  //           },
  //           certifications: certifications,
  //           employment_history: {
  //             1: {
  //               position: position,
  //               employer_name: employerName,
  //               start_date: startDate,
  //               end_date: endDate,
  //             },
  //             ...(position2 && {
  //               2: {
  //                 position: position2,
  //                 employer_name: employer2Name,
  //                 start_date: startDate2,
  //                 end_date: endDate2,
  //               },
  //             }),
  //           },
  //           attachments: {
  //             file_name: fileName,
  //             file_type: fileExtension,
  //             file_data: base64Data,
  //           },
  //           meta: resume
  //         };
  //       })
  //     );

  //     const validCandidates = candidates.filter(candidate => candidate !== null);

  //     if (validCandidates.length === 0) {
  //       triggerAlert("error", "No valid candidates to submit");
  //       return;
  //     }

  //     // Map duplicateAction to API expected values
  //     const duplicateActionMap = {
  //       "add_as_a_resume": "add",
  //       "overwrite_existing": "overwrite",
  //       "do_nothing": "skip"
  //     };

  //     const submitData = {
  //       job_id: parseInt(formData.selectedJob) || 1152,
  //       status: formData.selectedStage || "Received",
  //       candidate_source: parseInt(formData.candidateSource),
  //       category: parseInt(formData.selectedCategory) || 150,
  //       duplicate_action: duplicateActionMap[formData.duplicateAction] || "add",
  //       duplicate_check_field: formData.duplicateCriteria.toLowerCase(),
  //       candidates: validCandidates,
  //     };

  //     try {
  //       const response = await axios.post(
  //         `/api/v1/candidates/bulk_upload/?company_id=${companyId}`,
  //         submitData
  //       );

  //       if (response?.status === 200) {
  //         toast.current.show({
  //           severity: "success",
  //           summary: "Success",
  //           detail: "Resumes submitted successfully",
  //         });
  //         setActiveIndex(0);
  //         setUploadedFiles([]);
  //         setUploadedResumeData([]);
  //         setTotalSize(0);
  //         setFileSizes({});
  //         setSelectedCategoryKey(null);
  //         setSelectedStage("None");
  //         setSelectedJobTitles("");
  //         setSelectedJobs(null);
  //         setFormData({
  //           resumeFiles: [],
  //           duplicateAction: "add_as_a_resume",
  //           duplicateCriteria: "email",
  //           candidateSource: "",
  //           selectedCategory: null,
  //           selectedStage: "None",
  //           selectedJob: "",
  //         });
  //         navigate('/all_candidates');
  //       } else {
  //         triggerAlert(
  //           "error",
  //           "Failed to submit resumes: Unexpected response status"
  //         );
  //       }
  //     } catch (apiError) {
  //       const errorMessage =
  //         apiError.response?.data?.message ||
  //         apiError.response?.data?.detail ||
  //         apiError.message ||
  //         "Unknown error occurred";
  //       triggerAlert("error", `Failed to submit resumes: ${errorMessage}`);
  //       console.error("API Error Details:", apiError.response?.data);
  //     }
  //   } catch (error) {
  //     triggerAlert("error", `Error preparing data: ${error.message}`);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  const handleSubmit = async () => {
      if (!formData.candidateSource) {
    triggerAlert("error", "Candidate Source is mandatory. Please select a source.");
    return;
  }
    setIsLoading(true);
    try {
      const convertToBase64 = file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result.split(",")[1]);
          reader.onerror = error => reject(error);
        });
      };

      const candidates = await Promise.all(
        uploadedResumeData.map(async (resume, index) => {
          const file = uploadedFiles[index];
          if (!file) return null;

          const base64Data = await convertToBase64(file);
          const fileExtension = file.name.split(".").pop().toLowerCase();
          const fileName = file.name;

          const firstName = Array.isArray(resume.contact_info?.first_name)
            ? resume.contact_info.first_name[0] || "Unknown"
            : String(resume.contact_info?.first_name || "Unknown");
          const lastName = Array.isArray(resume.contact_info?.last_name)
            ? resume.contact_info.last_name[0] || ""
            : String(resume.contact_info?.last_name || "");
          const middleName = Array.isArray(resume.contact_info?.middle_name)
            ? resume.contact_info.middle_name[0] || ""
            : String(resume.contact_info?.middle_name || "");
          const email = Array.isArray(resume.contact_info?.email)
            ? resume.contact_info.email[0] || ""
            : String(resume.contact_info?.email || "");
          const phone = Array.isArray(resume.contact_info?.phone)
            ? resume.contact_info.phone[0] || ""
            : String(resume.contact_info?.phone || "");
          const totalExperience = Array.isArray(resume.contact_info?.total_experience)
            ? Number(resume.contact_info.total_experience[0]) +
            Number(resume.contact_info.total_experience[1] || 0) / 100
            : 0;
          const employerName = resume.employment_history?.employer_1?.employer_name || "";
          const position = resume.employment_history?.employer_1?.position || "";
          const startDate = resume.employment_history?.employer_1?.start_date || "";
          const endDate = resume.employment_history?.employer_1?.end_date || "";
          const employer2Name = resume.employment_history?.employer_2?.employer_name || "";
          const position2 = resume.employment_history?.employer_2?.position || "";
          const startDate2 = resume.employment_history?.employer_2?.start_date || "";
          const endDate2 = resume.employment_history?.employer_2?.end_date || "";
          const referredBy = resume.referred_by || "";
          const country = Array.isArray(resume.contact_info?.country)
            ? resume.contact_info.country[0] || ""
            : String(resume.contact_info?.country || "");
          const city = Array.isArray(resume.contact_info?.city)
            ? resume.contact_info.city[0] || ""
            : String(resume.contact_info?.city || "");
          const region = Array.isArray(resume.contact_info?.region)
            ? resume.contact_info.region[0] || ""
            : String(resume.contact_info?.region || "");
          const primarySkills = Array.isArray(resume.primary_skills)
            ? resume.primary_skills
            : [];
          const secondarySkills = Array.isArray(resume.secondary_skills)
            ? resume.secondary_skills
            : [];
          const otherSkills = Array.isArray(resume.other_skills)
            ? resume.other_skills
            : [];
          const degreeName = resume.education_history?.education_1?.degree_name || "";
          const schoolName = resume.education_history?.education_1?.school_name || "";
          const lastEducationDate = resume.education_history?.education_1?.last_education_date || "";
          const major1 = resume.education_history?.education_1?.major || "";
          const degreeName2 = resume.education_history?.education_2?.degree_name || "";
          const schoolName2 = resume.education_history?.education_2?.school_name || "";
          const lastEducationDate2 = resume.education_history?.education_2?.last_education_date || "";
          const major2 = resume.education_history?.education_2?.major || "";
          const certifications = Array.isArray(resume.extras?.certifications)
            ? resume.extras.certifications.map(cert => `${cert}, Unknown, Unknown`)
            : [];

          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (email && !emailRegex.test(email)) {
            toast.current.show({
              severity: "warn",
              summary: "Warning",
              detail: `Invalid email format for ${fileName}: ${email}.`,
            });
            return null;
          }

          if (!firstName || firstName.trim() === "") {
            toast.current.show({
              severity: "warn",
              summary: "Warning",
              detail: `First name is missing for ${fileName}.`,
            });
            return null;
          }

          return {
            first_name: firstName,
            middle_name: middleName,
            last_name: lastName,
            email: email,
            phone: phone,
            total_experience: totalExperience,
            employer_name: employerName,
            position: position,
            referred_by: referredBy,
            country: country,
            city: city,
            region: region,
            primary_skills: primarySkills,
            secondary_skills: secondarySkills,
            other_skills: otherSkills,
            education_history: {
              education_1: {
                school_name: schoolName,
                degree_name: degreeName,
                major: major1,
                last_education_date: lastEducationDate,
              },
              ...(degreeName2 && {
                education_2: {
                  school_name: schoolName2,
                  degree_name: degreeName2,
                  major: major2,
                  last_education_date: lastEducationDate2,
                },
              }),
            },
            certifications: certifications,
            employment_history: {
              1: {
                position: position,
                employer_name: employerName,
                start_date: startDate,
                end_date: endDate,
              },
              ...(position2 && {
                2: {
                  position: position2,
                  employer_name: employer2Name,
                  start_date: startDate2,
                  end_date: endDate2,
                },
              }),
            },
            attachments: {
              file_name: fileName,
              file_type: fileExtension,
              file_data: base64Data,
            },
            meta: resume
          };
        })
      );

      const validCandidates = candidates.filter(candidate => candidate !== null);

      if (validCandidates.length === 0) {
        triggerAlert("error", "No valid candidates to submit");
        return;
      }

      // Map duplicateAction to API expected values
      const duplicateActionMap = {
        "add_as_a_resume": "add",
        "overwrite_existing": "overwrite",
        "do_nothing": "skip"
      };

      const submitData = {
        job_id: parseInt(formData.selectedJob) || 1152,
        status: formData.selectedStage || "Received",
        candidate_source: parseInt(formData.candidateSource),
        category: parseInt(formData.selectedCategory) || 150,
        duplicate_action: duplicateActionMap[formData.duplicateAction] || "add",
        duplicate_check_field: formData.duplicateCriteria.toLowerCase(),
        candidates: validCandidates,
      };

    showResumeProcessingToast(10)
    const response = await axios.post(
      `/api/v1/candidates/bulk_upload/?company_id=${companyId}`,
      submitData,
      {
        onUploadProgress: progressEvent => {
          if (!progressEvent?.total) return;

          const uploadPercent = Math.min(
            80,
            35 + Math.round((progressEvent.loaded / progressEvent.total) * 45)
          );

          updateResumeProcessingProgress(uploadPercent);
        },
      }
    );
    if (response?.status === 202) {
      const taskId =
        response.data?.task_ids?.attachments_task ||
        response.data?.task_ids?.candidate_ids_task ||
        response.data?.task_ids?.task_id ||
        response.data?.attachments_task ||
        response.data?.task_id;

      if (!taskId) {
        throw new Error("Resume upload task id was not returned.");
      }

      activeParsingTaskIdRef.current = taskId;

      const taskResult = await waitForUploadTask(taskId);
      clearResumeProcessingToast(); 
      if (taskResult.status === "SUCCESS") {
        const { failed_resumes = [], success_resumes = [] } = taskResult.data || {};
        setFailedResumes(failed_resumes);
        setSuccessResumes(success_resumes);
        if (failed_resumes.length > 0 || success_resumes.length > 0) {
          setShowResultModal(true); 
        } else {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "All resumes submitted successfully",
          });
          resetAndNavigate();
        }
      } else {
        triggerAlert("error", "Task failed: " + (taskResult.error || "Unknown error"));
      }
    } else if (response?.status === 200) {
      clearResumeProcessingToast();
      const { failed_resumes = [], success_resumes = [] } = response.data || {};
      setFailedResumes(failed_resumes);
      setSuccessResumes(success_resumes);
      if (failed_resumes.length > 0 || success_resumes.length > 0) {
        setShowResultModal(true);
      } else {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "All resumes submitted successfully",
        });
        resetAndNavigate();
      }
    } else {
      clearResumeProcessingToast();
      triggerAlert("error", "Failed to submit resumes: Unexpected response status");
    }
  } catch (error) {
    clearResumeProcessingToast();
    if (parsingCancelledRef.current) return;
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Unknown error occurred";
    triggerAlert("error", `Failed to submit resumes: ${errorMessage}`);
    console.error("API Error Details:", error.response?.data);
  } finally {
    setIsLoading(false);
  }
};


const resetAndNavigate = () => {
  setActiveIndex(0);
  setUploadedFiles([]);
  setUploadedResumeData([]);
  setTotalSize(0);
  setFileSizes({});
  setSelectedCategoryKey(null);
  setSelectedStage("None");
  setSelectedJobTitles("");
  setSelectedJobs(null);
  setFormData({
    resumeFiles: [],
    duplicateAction: "add_as_a_resume",
    duplicateCriteria: "Email",
    candidateSource: "",
    selectedCategory: null,
    selectedStage: "None",
    selectedJob: "",
  });
  navigate("/all_candidates");
};
  const handleNext = async () => {
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    const hasInvalidType = uploadedFiles?.some(file => !allowedTypes?.includes(file.type));

    if (activeIndex === 0 && await hasLegacyWordDocument(uploadedFiles)) {
      await Swal.fire({
        icon: "warning",
        title: "Microsoft Word 97-2003 Document",
        text: "This .doc file cannot be parsed. Please upload the resume in PDF or DOCX format.",
        confirmButtonText: "OK",
      });
      return;
    }

    if (hasInvalidType) {
      triggerAlert("error", "Invalid file type detected. Only PDF, DOC, and DOCX files are allowed.");
      return;
    }

    if (totalSize > 5000000) {
      triggerAlert("error", "Total file size exceeds 5MB limit. Please remove some files before proceeding.");
      return;
    }

    if (activeIndex === 0) {
      if (uploadedFiles.length === 0) {
        triggerAlert("error", "Please upload at least one resume");
        return;
      }
      const success = await uploadResumesToApi();
      if (!success) return;
    } else if (activeIndex === 1) {
      const duplicateActionValue = document.querySelector('input[name="category"]:checked')?.value;
      const duplicateAction =
        duplicateActionValue === "add_as_a_resume" ? "add" :
          duplicateActionValue === "overwrite_existing" ? "overwrite" :
            duplicateActionValue === "do_nothing" ? "skip" :
              formData.duplicateAction;
      const duplicateCriteria =
        document.querySelector(".form-select")?.value ||
        formData.duplicateCriteria;
      setFormData(prev => ({
        ...prev,
        duplicateAction: duplicateAction,
        duplicateCriteria: duplicateCriteria === "Email" ? "email" : "phone",
      }));
    } else if (activeIndex === 2) {
        setSourceError("");
      const candidateSource =
        document.querySelector(".form-select")?.value ||
        formData.candidateSource;
      // if (!selectedCategoryKey) {
      //   triggerAlert("error", "Category is mandatory. Please select a category.");
      //   return;
      // }
        if (!formData.candidateSource) {
      triggerAlert("error", "Candidate Source is mandatory. Please select a source.");
      return;
    }
      setFormData(prev => ({
        ...prev,
        candidateSource: formData.candidateSource,
        selectedCategory: selectedCategoryKey,
        selectedStage,
      }));
    }
    setActiveIndex(prev => Math.min(prev + 1, steps.length - 1));
  };


  const headerTemplate = options => {
    const { className, chooseButton, cancelButton } = options
    const value = totalSize / 5000000
    const formatedValue =
      fileUploadRef && fileUploadRef.current
        ? fileUploadRef.current.formatSize(totalSize)
        : "0 B"

    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
        {chooseButton}
        {cancelButton}
        <div className="flex align-items-center gap-3 ml-auto">
          <span>{formatedValue} / 5 MB</span>
          <ProgressBar
            value={value * 100}
            showValue={false}
            style={{ width: "10rem", height: "12px" }}
          ></ProgressBar>
        </div>
      </div>
    )
  }


  // const itemTemplate = (file, props) => {
  //   const isPdf = file?.type === "application/pdf";
  //   const isWord = [
  //     "application/msword",
  //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //   ].includes(file.type);

  //   const handleFileClick = () => {
  //     const url = URL.createObjectURL(file);
  //     window.open(url, "_blank");
  //     setTimeout(() => URL.revokeObjectURL(url), 1000);
  //   };

  //   return (
  //     <div className="flex align-items-center flex-wrap bulk-resume">
  //       <div className="flex align-items-center" style={{ width: "40%" }}>
  //         <i
  //           className={`pi ${isPdf ? "pi-file-pdf" : isWord ? "pi-file-word" : "pi-file"} mr-3`}
  //           style={{
  //             fontSize: "2em",
  //             color: isPdf ? "#ff0000" : isWord ? "#2b579a" : "#666",
  //           }}
  //         ></i>
  //         <span className="flex flex-column text-left">
  //           <a
  //             href="#"
  //             onClick={e => {
  //               e.preventDefault();
  //               handleFileClick();
  //             }}
  //             style={{
  //               color: "#007bff",
  //               textDecoration: "none",
  //               cursor: "pointer",
  //             }}
  //             onMouseOver={e => (e.currentTarget.style.textDecoration = "underline")}
  //             onMouseOut={e => (e.currentTarget.style.textDecoration = "none")}
  //           >
  //             {file.name}
  //           </a>
  //           <small>{new Date().toLocaleDateString()}</small>
  //         </span>
  //       </div>
  //       <Tag value={props?.formatSize} severity="warning" className="px-3 py-2" />
  //       <Button
  //         icon="pi pi-times"
  //         className="p-button-danger ml-auto"
  //         onClick={() => onTemplateRemove(file, props.onRemove)}
  //       />
  //     </div>
  //   );
  // };

  const itemTemplate = (file, props) => {
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    const allowedExtensions = [".pdf", ".doc", ".docx"];

    const ext = file.name?.substring(file.name.lastIndexOf("."))?.toLowerCase();
    const isValid = allowedTypes?.includes(file.type) && allowedExtensions?.includes(ext);

    if (!isValid) {
      // ❌ Do not render invalid file in UI
      return null;
    }

    const isPdf = file?.type === "application/pdf";
    const isWord = allowedTypes?.slice(1)?.includes(file.type);
    const fileExtension = ext.replace(".", "").toUpperCase();
    const modifiedDate = file.lastModified
      ? new Date(file.lastModified).toLocaleString()
      : "Unavailable";
    const fileSize = file.size >= 1024 * 1024
      ? `${(file.size / (1024 * 1024)).toFixed(2)} MB`
      : `${(file.size / 1024).toFixed(1)} KB`;

    return (
      <div className="resume-file-card">
        <div className="resume-file-icon-wrap">
          {isPdf ? <FaFilePdf className="resume-native-file-icon resume-file-pdf-icon" /> : isWord ? <FaFileWord className="resume-native-file-icon resume-file-word-icon" /> : <i className="pi pi-file resume-native-file-icon" />}
        </div>
        <div className="resume-file-details">
          <strong title={file.name}>{file.name}</strong>
          <div className="resume-file-property-grid">
            <span><b>Format</b>{fileExtension}</span>
            <span><b>Size</b>{fileSize}</span>
            <span><b>Type</b>{file.type || "Unavailable"}</span>
            <span><b>Modified</b>{modifiedDate}</span>
          </div>
        </div>
        <Tag value="Ready to parse" severity="success" className="resume-file-status" />
        <Button
          icon="pi pi-times"
          className="p-button-danger ml-auto"
          // onClick={() => onTemplateRemove(file, () => {})}
          onClick={() => onTemplateRemove(file, props.onRemove)} // ✅ pass real callback
        />
      </div>
    );
  };


  const emptyTemplate = () => {
    return (
      <div className="flex align-items-center flex-column">
        <i
          className="pi pi-file mt-3 p-5"
          style={{
            fontSize: "5em",
            borderRadius: "50%",
            backgroundColor: "var(--surface-b)",
            color: "var(--surface-d)",
          }}
        ></i>
        <span
          style={{ fontSize: "1.2em", color: "var(--text-color-secondary)" }}
          className="my-5"
        >
          Upload PDF, DOC, or DOCX Files Here
        </span>
      </div>
    );
  };

  const deleteResume = (resumeToDelete) => {
    const fileName = resumeToDelete.file_name.trim().toLowerCase();
    const fileSize = fileSizes[fileName] || 0;

    // Update uploadedResumeData by filtering out the resume to delete
    setUploadedResumeData(prev =>
      prev.filter(resume =>
        !(resume.id === resumeToDelete.id && resume.file_name === resumeToDelete.file_name)
      )
    );

    // Update uploadedFiles by filtering out the corresponding file
    const updatedFiles = uploadedFiles.filter(
      file => file.name.trim().toLowerCase() !== fileName
    );

    // Update total size and file sizes
    setTotalSize(prev => Math.max(prev - fileSize, 0));
    setUploadedFiles(updatedFiles);
    setFileSizes(prev => {
      const newSizes = { ...prev };
      delete newSizes[fileName];
      return newSizes;
    });

    // Update formData to reflect the removed file
    setFormData(prev => ({
      ...prev,
      resumeFiles: updatedFiles,
    }));

    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Resume deleted successfully",
    });
  };

  const chooseOptions = {
    icon: "pi pi-fw pi-file",
    iconOnly: true,
    className: "custom-choose-btn p-button-rounded p-button-outlined",
  }
  const cancelOptions = {
    icon: "pi pi-fw pi-times",
    iconOnly: true,
    className:
      "custom-cancel-btn p-button-danger p-button-rounded p-button-outlined",
  }

  const renderStepContent = () => {
    if (isLoading) {
      return (
        <div
          className="flex justify-content-center align-items-center"
          style={{ height: "50vh" }}
        >
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="8"
            animationDuration=".5s"
          />
        </div>
      )
    }

    switch (activeIndex) {
      case 0:
        return (
          <>
          <h6 className="page-title mb-3">Upload Resumes</h6>
            
            
            <div
              className="upload-resumes"
              style={{
                maxHeight: "50vh",
                overflowY: "auto",
                padding: "1rem",
                border: "1px solid #dee2e6",
                borderRadius: "4px",
              }}
            >
              <Tooltip
                target=".custom-choose-btn"
                content="Choose"
                position="bottom"
              />
              <Tooltip
                target=".custom-cancel-btn"
                content="Clear"
                position="bottom"
              />
              <FileUpload
                ref={fileUploadRef}
                name="resume_files"
                url="/api/upload"
                multiple
                accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                customUpload
                maxFileSize={5242400}
                files={uploadedFiles}
                onUpload={onTemplateUpload}
                onSelect={onTemplateSelect}
                onError={onTemplateClear}
                onClear={onTemplateClear}
                headerTemplate={headerTemplate}
                itemTemplate={itemTemplate}
                emptyTemplate={emptyTemplate}
                chooseOptions={chooseOptions}
                cancelOptions={cancelOptions}
              />
            </div>
          </>
        )
      case 1:
        return (
          <Row>
            <Col md={12}>
              <div className="import-step-card">
                <div className="import-step-header">
                  <div>
                    <h6>Duplicate Check</h6>
                    <p>
                      Please choose an action to take if a duplicate resume is
                      detected during the upload.
                    </p>
                  </div>
                </div>
                <div className="import-duplicate-grid">
                  <label className={`import-option-card ${formData?.duplicateAction === "add_as_a_resume" ? "active" : ""}`} htmlFor="add_as_a_resume">
                    <RadioButton
                      id="add_as_a_resume"
                      inputId="add_as_a_resume"
                      name="category"
                      value="add_as_a_resume"
                      checked={formData?.duplicateAction === "add_as_a_resume"}
                      onChange={e =>
                        setFormData(prev => ({
                          ...prev,
                          duplicateAction: e.target.value,
                        }))
                      }
                    />
                    <span>
                      <strong>Add as a Resume</strong>
                      <small>Select this option to create a new candidate profile in the system.</small>
                    </span>
                  </label>
                  <label className={`import-option-card ${formData?.duplicateAction === "overwrite_existing" ? "active" : ""}`} htmlFor="overwrite_existing">
                    <RadioButton
                      inputId="overwrite_existing"
                      name="category"
                      value="overwrite_existing"
                      checked={
                        formData?.duplicateAction === "overwrite_existing"
                      }
                      onChange={e =>
                        setFormData(prev => ({
                          ...prev,
                          duplicateAction: e.target.value,
                        }))
                      }
                    />
                    <span>
                      <strong>Overwrite Existing</strong>
                      <small>Replace the existing resume and move the old resume to documents.</small>
                    </span>
                  </label>
                  <label className={`import-option-card ${formData?.duplicateAction === "do_nothing" ? "active" : ""}`} htmlFor="do_nothing">
                    <RadioButton
                      inputId="do_nothing"
                      name="category"
                      value="do_nothing"
                      checked={formData?.duplicateAction === "do_nothing"}
                      onChange={e =>
                        setFormData(prev => ({
                          ...prev,
                          duplicateAction: e.target.value,
                        }))
                      }
                    />
                    <span>
                      <strong>Do Nothing</strong>
                      <small>Take no action when a duplicate record is detected.</small>
                    </span>
                  </label>
                </div>
                <div className="import-step-field">
                  <label>Criteria for Identifying Duplicates:</label>
                  <select
                    className="form-select"
                    value={formData?.duplicateCriteria}
                    onChange={e =>
                      setFormData(prev => ({
                        ...prev,
                        duplicateCriteria: e.target.value,
                      }))
                    }
                  >
                    <option>Email</option>
                    <option>Phone Number</option>
                  </select>
                </div>
              </div>
            </Col>
          </Row>
        )
      case 2:
        return (
          <Row>
            <Col md={12}>
              <div className="import-step-card">
                <div className="import-step-header">
                  <div>
                    <h6>Tag Resumes</h6>
                    <p>Add source, category, stage, and linked jobs to all imported candidates.</p>
                  </div>
                </div>
                <div className="import-tag-grid">
                  <div className="import-step-field">
                    <label>Candidate Source <span className="text-danger">*</span></label>
                    <select
                      className="form-select"
                      style={{ cursor: "pointer" }}
                      value={formData?.candidateSource}
                      onChange={e =>
                        setFormData(prev => ({
                          ...prev,
                          candidateSource: e.target.value,
                        }))
                      }
                    >
                      <option value="">-- Select Source --</option>
                      {resumeSources?.length > 0 ? (
                        resumeSources?.map(source => (
                          <option key={source?.source_id} value={source?.source_id}>
                            {source?.resume_source}
                          </option>
                        ))
                      ) : (
                        <option value="">No sources available</option>
                      )}
                    </select>
                    {sourceError && <small className="text-danger d-block mt-1">{sourceError}</small>}
                    <small>Select value updates candidate source for all imported candidates.</small>
                  </div>
                  <div className="import-step-field">
                    <label>Categories</label>
                    <TreeSelect
                      value={selectedCategoryKey}
                      onChange={e => {
                        setSelectedCategoryKey(e.value)
                        setFormData(prev => ({
                          ...prev,
                          selectedCategory: e.value,
                        }))
                      }}
                      options={categories}
                      filter
                      className="w-100"
                      placeholder="Select Category"
                    ></TreeSelect>
                    <small>Categories candidates with the selected values.</small>
                  </div>
                  <div className="import-step-field import-step-field-full">
                    <label>Pipeline Stage</label>
                    <div className="import-stage-pills">
                      {stages?.map(stage => (
                        <label htmlFor={stage?.id} className={selectedStage === stage?.name ? "active" : ""} key={stage.id}>
                          <RadioButton
                            inputId={stage?.id}
                            name="stage"
                            value={stage?.name}
                            checked={selectedStage === stage?.name}
                            onChange={e => {
                              setSelectedStage(e.target.value)
                              setFormData(prev => ({
                                ...prev,
                                selectedStage: e.target.value,
                              }))
                            }}
                          />
                          {stage.name}
                        </label>
                      ))}
                      <label htmlFor="none" className={selectedStage === "None" ? "active" : ""}>
                        <RadioButton
                          inputId="none"
                          name="stage"
                          value="None"
                          checked={selectedStage === "None"}
                          onChange={e => {
                            setSelectedStage(e.target.value)
                            setFormData(prev => ({
                              ...prev,
                              selectedStage: e.target.value,
                            }))
                          }}
                        />
                        None
                      </label>
                    </div>
                  </div>
                  <div className="import-step-field import-step-field-full">
                    <label>Link Jobs</label>
                    <div className="p-inputgroup">
                      <InputText
                        value={selectedJobTitles}
                        onClick={handleIconClick}
                        style={{ cursor: "pointer" }}
                        placeholder="Select Job"
                        className="w-full"
                        readOnly
                      />
                      <span className="p-inputgroup-addon" style={{ cursor: "pointer" }}>
                        <i
                          className="pi pi-chevron-down"
                          onClick={handleIconClick}
                        ></i>
                      </span>
                    </div>
                  </div>
                  <Dialog
                    header="Select Job"
                    visible={jobDetailsVisible}
                    onHide={() => setJobDetailsVisible(false)}
                    style={{ width: "40vw" }}
                    breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                    className="job-details"
                  >
                    <Row>
                      <Col lg={12}>
                        <div
                          className="p-inputgroup mb-3"
                          style={{ position: "relative" }}
                        >
                          <InputText
                            placeholder="Search Jobs"
                            value={searchText}
                            onInput={e => setSearchText(e.target.value)}
                            style={{ paddingRight: "2rem" }}
                          />
                          <i
                            className="pi pi-search"
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                            }}
                          ></i>
                        </div>
                      </Col>
                    </Row>
                    <DataTable
                      value={jobs.filter(
                        job =>
                          job?.job_title?.toLowerCase().includes(searchText?.toLowerCase()) ||
                          job?.job_number.toLowerCase().includes(searchText?.toLowerCase())
                      )}
                      paginator
                      first={lazyParams.page * lazyParams.rows}
                      rows={lazyParams.rows}
                      totalRecords={totalRecords}
                      onPage={onPageChange}
                      selection={selectedJobs}
                      onSelectionChange={e => setSelectedJobs(e.value)}
                      selectionMode="single"
                      loading={isLoading}
                      dataKey="job_id"
                      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                      currentPageReportTemplate="{first} to {last} of {totalRecords}"
                      rowsPerPageOptions={[5, 10, 25, totalRecords]}
                      size="small"
                      id="JobDatatable"
                      lazy
                    >
                      <Column selectionMode="single" style={{ width: "3em" }} />
                      <Column field="job_title" header="Job Title" />
                      {/* <Column field="hiring_manager_name" header="Contact" /> */}
                    </DataTable>
                    <div className="d-flex mt-3">
                      <Button
                        label="Ok"
                        className="p-button-primary me-2 blueBtn"
                        onClick={handleSaveJobs}
                      />
                      <Button
                        label="Refresh"
                        className="p-button-primary blueBtn"
                        onClick={handleRefreshJobs}
                      />
                    </div>
                  </Dialog>
                </div>
              </div>
            </Col>
          </Row>
        )
      case 3:
        return (
          <Row>
            <Col md={12}>
              <h6 className="page-title mb-3">Finish</h6>
              <div className="card p-3" id="CandidateFinishTable">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Candidate Name</th>
                      <th>Email</th>
                      <th>File Size</th>
                      <th>File Type</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {uploadedResumeData?.length > 0 ? (
                      uploadedResumeData?.map((resume, index) => {
                        const fileSize = resume?.file_size || 0;
                        // Find the corresponding file in uploadedFiles using file_name
                        const matchingFile = uploadedFiles.find(
                          file => file.name.trim().toLowerCase() === resume.file_name?.trim().toLowerCase()
                        );

                        // console.log(
                        //   `Resume ${index + 1} - File: ${resume.file_name
                        //   }, Size: ${fileSize
                        //     ? (fileSize / 1000000).toFixed(2) + " MB"
                        //     : "0.00 MB"
                        //   }`
                        // );

                        return (
                          <tr key={`${resume.id}-${resume.file_name}`}> {/* Use a composite key */}
                            <td>{`${resume?.contact_info?.first_name || "N/A"} ${resume?.contact_info?.middle_name || ""}  ${resume?.contact_info?.last_name || ""
                              }`}</td>
                            <td>{resume?.contact_info?.email || "N/A"}</td>
                            <td>
                              {fileSize
                                ? `${(fileSize / 1000000).toFixed(2)} MB`
                                : "0.00 MB"}
                            </td>
                            <td>
                              {matchingFile?.type
                                ?.split("/")[1]
                                ?.toUpperCase()
                                .replace("VND.OPENXMLFORMATS-OFFICEDOCUMENT.WORDPROCESSINGML.DOCUMENT", "DOCX") || "N/A"}
                            </td>
                            <td>
                              <button type="button" className="btn btn-sm btn-primary me-2" title="View Profile" onClick={() => { setSelectedResume(resume);setViewVisible(true);}}>
                                  <i className="pi pi-eye" style={{ cursor: "pointer" }}></i>
                              </button>

                              <button type="button" className="btn btn-sm btn-warning me-2" title="Edit Profile" onClick={() => { setEditResume({ ...resume }); setEditVisible(true);}}>
                                  <i className="pi pi-pencil" style={{ cursor: "pointer" }}></i>
                              </button>

                              <button type="button" className="btn btn-sm btn-danger" title="Delete Resume" onClick={() => deleteResume(resume)}>
                                  <i className="pi pi-trash" style={{ cursor: "pointer" }}></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="5">No resume data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        );
      default:
        return null
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Toast ref={toast} position="top-right" />
          <div className="page-title-box">
            <Row className="mb-3">
              <Col xl={12}>
                <div className="d-flex justify-content-end">
                      <label className="me-2 mt-2">Select Company</label>
                      <div style={{ width: "200px"}}>
                        <CompanySelector onCompanyChange={handleCompanyChange} />
                    </div>
                </div>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xl={12}>
                <Steps
                  model={steps}
                  activeIndex={activeIndex}
                  onSelect={e => setActiveIndex(e.index)}
                  readOnly={false}
                />
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "calc(100vh - 200px)",
              }}
            >
              <div style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
                <Row>
                  <Col xl={12}>{renderStepContent()}</Col>
                </Row>
              </div>
              <Row className="mt-3" style={{ paddingBottom: "3rem" }}>
                <Col className="d-flex justify-content-between">
                  <Button
                    onClick={() => setActiveIndex(prev => Math.max(prev - 1, 0))}
                    disabled={activeIndex === 0 || isLoading}
                    className="main-button"
                  >
                    Previous
                  </Button>
                  <div>
                    {activeIndex < steps?.length - 1 && (
                      <Button
                        className="main-button"
                        onClick={handleNext}
                        disabled={isLoading || (activeIndex === 0 && totalSize > 5000000)}
                      >
                        Next
                      </Button>
                    )}
                    {activeIndex === steps?.length - 1 && (
                      <Button
                        className="main-button"
                        onClick={handleSubmit}
                        disabled={isLoading}
                      >
                        Submit
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </div>

            <div className="flex justify-content-center">
              <Dialog
                header="PROFILE INFORMATION"
                visible={viewVisible}
                style={{ width: "60vw" }}
                onHide={() => {
                  if (!viewVisible) return
                  setViewVisible(false)
                  setSelectedResume(null)
                }}
              >
                {selectedResume && (
                  <div className="mb-5">
                    <Row>
                      <Col xl={12}>
                        <div className="mt-5">
                          <div className="flex flex-wrap gap-3 mb-4">
                            <div className="flex-auto">
                              <label
                                htmlFor="display_name"
                                className="block mb-2"
                              >
                                Display Name
                              </label>
                              <InputText
                                id="display_name"
                                value={`${selectedResume?.contact_info?.first_name} ${selectedResume?.contact_info?.middle_name || ""} ${selectedResume?.contact_info?.last_name}`}
                                className="w-full"
                                readOnly
                              />
                            </div>
                            <div className="flex-auto">
                              <label htmlFor="job_title" className="block mb-2">
                                Job Title
                              </label>
                              <InputText
                                id="job_title"
                                value={
                                  selectedResume?.employment_history?.employer_1
                                    ?.position || "N/A"
                                }
                                className="w-full"
                                readOnly
                              />
                            </div>
                            <div className="flex-auto">
                              <label htmlFor="city" className="block mb-2">
                                City
                              </label>
                              <InputText
                                id="city"
                                value={
                                  selectedResume?.contact_info?.city || "N/A"
                                }
                                className="w-full"
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="flex flex-wrap gap-3 mb-4">
                            <div className="flex-auto">
                              <label htmlFor="email" className="block mb-2">
                                Email
                              </label>
                              <InputText
                                id="email"
                                value={
                                  selectedResume?.contact_info?.email || "N/A"
                                }
                                className="w-full"
                                readOnly
                              />
                            </div>
                            <div className="flex-auto">
                              <label htmlFor="phone" className="block mb-2">
                                Phone
                              </label>
                              <InputText
                                id="phone"
                                value={
                                  selectedResume?.contact_info?.phone || "N/A"
                                }
                                className="w-full"
                                readOnly
                              />
                            </div>
                            <div className="flex-auto">
                              <label htmlFor="state" className="block mb-2">
                                State
                              </label>
                              <InputText
                                id="state"
                                value={
                                  selectedResume?.contact_info?.region || "N/A"
                                }
                                className="w-full"
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="flex flex-wrap gap-3">
                            <div className="flex-auto">
                              <label htmlFor="education" className="block mb-2">
                                Education
                              </label>
                              <InputText
                                id="education"
                                value={
                                  selectedResume?.education_history?.education_1
                                    ?.degree_name || "N/A"
                                }
                                className="w-full"
                                readOnly
                              />
                            </div>
                            <div className="flex-auto">
                              <label htmlFor="skills" className="block mb-2">
                                Primary Skills
                              </label>
                              <InputText
                                id="skills"
                                value={
                                  selectedResume?.primary_skills?.join(", ") ||
                                  "N/A"
                                }
                                className="w-full"
                                readOnly
                              />
                            </div>
                            <div className="flex-auto">
                              <label htmlFor="country" className="block mb-2">
                                Country
                              </label>
                              <InputText
                                id="country"
                                value={
                                  selectedResume?.contact_info?.country || "N/A"
                                }
                                className="w-full"
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="flex flex-wrap gap-3 mt-4 d-none">
                            <div className="flex-auto">
                              <label
                                htmlFor="certifications"
                                className="block mb-2"
                              >
                                Certifications
                              </label>
                              <InputText
                                id="certifications"
                                value={
                                  selectedResume?.extras?.certifications?.join(
                                    ", "
                                  ) || "N/A"
                                }
                                className="w-full"
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}
              </Dialog>
              <Dialog
                header="EDIT PROFILE INFORMATION"
                visible={editVisible}
                style={{ width: "min(960px, calc(100vw - 48px))" }}
                className="edit-profile-dialog"
                onHide={() => {
                  if (!editVisible) return
                  cancelEditResume()
                }}
                footer={
                  <div className="edit-profile-footer">
                    <Button
                      label="Cancel"
                      icon="pi pi-times"
                      onClick={cancelEditResume}
                      className="p-button-text"
                      disabled={isLoading}
                    />
                    <Button
                      label="Save"
                      icon="pi pi-check"
                      onClick={saveEditedResume}
                      className="p-button-raised"
                      disabled={isLoading}
                    />
                  </div>
                }
              >
                {editResume && (
                  <div className="edit-profile-body">
                    <Row>
                      <Col xl={12}>
                        <div className="edit-profile-form">
                          <div className="flex flex-wrap gap-3 mb-4">
                            <div className="flex-auto">
                              <label
                                htmlFor="edit_display_name"
                                className="block mb-2"
                              >
                                Display Name
                              </label>
                              <InputText
                                id="edit_display_name"
                                value={`${editResume?.contact_info?.first_name || ""
                                  } ${editResume?.contact_info?.middle_name || ""
                                  }${editResume?.contact_info?.last_name || ""}`}
                                className="w-full"
                                onChange={e => {
                                  const [first, last] =
                                    e.target.value.split(" ")
                                  setEditResume({
                                    ...editResume,
                                    contact_info: {
                                      ...editResume?.contact_info,
                                      first_name: first
                                        ? first?.substring(0, 30)
                                        : "",
                                      last_name: last || "",
                                    },
                                  })
                                }}
                              />
                            </div>
                            <div className="flex-auto">
                              <label
                                htmlFor="edit_job_title"
                                className="block mb-2"
                              >
                                Job Title
                              </label>
                              <InputText
                                id="edit_job_title"
                                value={
                                  editResume?.employment_history?.employer_1
                                    ?.position || ""
                                }
                                className="w-full"
                                onChange={e =>
                                  setEditResume({
                                    ...editResume,
                                    employment_history: {
                                      ...editResume?.employment_history,
                                      employer_1: {
                                        ...editResume?.employment_history
                                          ?.employer_1,
                                        position: e.target.value,
                                      },
                                    },
                                  })
                                }
                              />
                            </div>
                            <div className="flex-auto">
                              <label
                                htmlFor="edit_country"
                                className="block mb-2"
                              >
                                Country
                              </label>
                              <Dropdown
                                id="edit_country"
                                value={editResume?.contact_info?.country || ""}
                                options={countries?.map(country => ({
                                  label: country?.name,
                                  value: country?.name,
                                  countryId: country?.country_id,
                                }))}
                                onChange={e => {
                                  const selectedCountry = countries?.find(
                                    country => country.name === e.value
                                  )
                                  setSelectedCountryId(
                                    selectedCountry?.country_id || null
                                  )
                                  setSelectedStateId(null)
                                  setCities([])
                                  setEditResume({
                                    ...editResume,
                                    contact_info: {
                                      ...editResume?.contact_info,
                                      country: e.value,
                                      region: "",
                                      city: "",
                                    },
                                  })
                                  if (selectedCountry?.country_id) {
                                    fetchStates(selectedCountry?.country_id)
                                  }
                                }}
                                className="w-full"
                                placeholder="Select Country"
                                filter
                              />
                            </div>
                          </div>
                          <div className="flex flex-wrap gap-3 mb-4">
                            <div className="flex-auto">
                              <label
                                htmlFor="edit_email"
                                className="block mb-2"
                              >
                                Email
                              </label>
                              <InputText
                                id="edit_email"
                                value={editResume?.contact_info?.email || ""}
                                className="w-full"
                                onChange={e =>
                                  setEditResume({
                                    ...editResume,
                                    contact_info: {
                                      ...editResume?.contact_info,
                                      email: e.target.value.substring(0, 30),
                                    },
                                  })
                                }
                              />
                            </div>
                            <div className="flex-auto">
                              <label
                                htmlFor="edit_phone"
                                className="block mb-2"
                              >
                                Phone
                              </label>
                              <InputText
                                id="edit_phone"
                                value={editResume?.contact_info?.phone || ""}
                                className="w-full"
                                onChange={e =>
                                  setEditResume({
                                    ...editResume,
                                    contact_info: {
                                      ...editResume?.contact_info,
                                      phone: e.target.value.substring(0, 15),
                                    },
                                  })
                                }
                              />
                            </div>
                            <div className="flex-auto">
                              <label
                                htmlFor="edit_state"
                                className="block mb-2"
                              >
                                State
                              </label>
                              <Dropdown
                                id="edit_state"
                                value={editResume?.contact_info?.region || ""}
                                options={states?.map(state => ({
                                  label: state.name,
                                  value: state.name,
                                  stateId: state.state_id,
                                }))}
                                onChange={e => {
                                  const selectedState = states?.find(
                                    state => state.name === e.value
                                  )
                                  setSelectedStateId(
                                    selectedState?.state_id || null
                                  )
                                  setEditResume({
                                    ...editResume,
                                    contact_info: {
                                      ...editResume?.contact_info,
                                      region: e.value,
                                      city: "",
                                    },
                                  })
                                  if (selectedState?.state_id) {
                                    fetchCities(selectedState?.state_id)
                                  }
                                }}
                                className="w-full"
                                placeholder="Select State"
                                filter
                              />
                            </div>
                          </div>
                          <div className="flex flex-wrap gap-3">
                            <div className="flex-auto">
                              <label
                                htmlFor="edit_education"
                                className="block mb-2"
                              >
                                Education
                              </label>
                              <InputText
                                id="edit_education"
                                value={
                                  editResume?.education_history?.education_1
                                    ?.degree_name || ""
                                }
                                className="w-full"
                                onChange={e =>
                                  setEditResume({
                                    ...editResume,
                                    education_history: {
                                      ...editResume?.education_history,
                                      education_1: {
                                        ...editResume?.education_history
                                          ?.education_1,
                                        degree_name: e.target.value,
                                      },
                                    },
                                  })
                                }
                              />
                            </div>
                            <div className="flex-auto">
                              <label
                                htmlFor="edit_skills"
                                className="block mb-2"
                              >
                                Primary Skills
                              </label>
                              <MultiSelect
                                id="edit_skills"
                                value={editResume?.primary_skills || []}
                                options={skills?.map(skill => ({
                                  label: skill.skill_name,
                                  value: skill.skill_name,
                                }))}
                                onChange={e =>
                                  setEditResume({
                                    ...editResume,
                                    primary_skills: e.value,
                                  })
                                }
                                className="w-full"
                                placeholder="Select Skills"
                                filter
                                display="chip"
                              />
                            </div>
                            <div className="flex-auto">
                              <label htmlFor="edit_city" className="block mb-2">
                                City
                              </label>
                              <Dropdown
                                id="edit_city"
                                value={editResume.contact_info?.city || ""}
                                options={cities?.map(city => ({
                                  label: city.name,
                                  value: city.name,
                                }))}
                                onChange={e =>
                                  setEditResume({
                                    ...editResume,
                                    contact_info: {
                                      ...editResume?.contact_info,
                                      city: e.value,
                                    },
                                  })
                                }
                                className="w-full"
                                placeholder="Select City"
                                filter
                              />
                            </div>
                          </div>
                          <div className="flex flex-wrap gap-3 mt-4 d-none">
                            <div className="flex-auto">
                              <label
                                htmlFor="edit_certifications"
                                className="block mb-2"
                              >
                                Certifications
                              </label>
                              <InputText
                                id="edit_certifications"
                                value={
                                  Array.isArray(editResume?.extras?.certifications) &&
                                    editResume.extras.certifications.length > 0
                                    ? editResume.extras.certifications.join(", ")
                                    : ""
                                }
                                className="w-full"
                                onChange={e =>
                                  setEditResume({
                                    ...editResume,
                                    extras: {
                                      ...editResume?.extras,
                                      certifications: e.target.value
                                        .split(",")
                                        .map(cert => cert.trim()),
                                    },
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}
              </Dialog>
            </div>
          </div>
        </Container>
      </div>
      <style jsx>{`
        .page-content {
          display: flex;
          flex-direction: column;
          min-height: 100vh;
        }
        .page-title-box {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .main-button {
          margin: 0 5px;
        }
      `}</style>
      <Modal
        show={showResultModal}
        onHide={() => setShowResultModal(false)}
        size="lg"
        centered
        id="BulkUploadModal"
        backdrop="static"
      >
        <Modal.Header closeButton>
          
          <Modal.Title>Bulk Upload Result</Modal.Title>
        </Modal.Header>
        <div className="d-flex justify-content-start flex-column align-items-center p-3 rounded">
              <div className="fw-bold">
                Total Uploaded: {successResumes.length + failedResumes.length}
              </div>
              <div className="text-success fw-bold">
                Success: {successResumes.length}
              </div>
              <div className="text-danger fw-bold">
                Failed: {failedResumes.length}
              </div>
            </div>

        <Modal.Body>
          {/* {successResumes.length > 0 && (
            <>
              <h5 className="text-success">Successfully Uploaded Resumes</h5>
              <table className="table table-bordered table-striped mb-4">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>File Name</th>
                    <th>Candidate ID</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {successResumes.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.file_name}</td>
                      <td>{item.candidate_id}</td>
                      <td>{item.action}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )} */}

          {failedResumes.length > 0 && (
            <>
              <h5 className="text-danger">Failed Resumes</h5>
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>File Name</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {failedResumes.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.file_name}</td>
                      <td className="text-danger fw-bold">{item.action}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <Button variant="secondary" className=" btn btn-primary blueBtn d-none" onClick={() => setShowResultModal(false)}>
            Close
          </Button>
          <Button variant="primary" className="btn btn-primary blueBtn" onClick={() => navigate('/all_candidates')}>
            Go to Candidates List
          </Button>
        </Modal.Footer>
      </Modal>

    </React.Fragment>
  )
}

ImportBulkResume.propTypes = {
  triggerAlert: PropTypes.func,
}

export default ImportBulkResume
